import React from 'react';
import styled from 'styled-components';
import TextWrapper from '../TextWrapper';

const Wrapper = styled.div`
    padding-bottom: 0px;
    transition: 0.5s;
    -webkit-transition: 0.5s;
    -o-transition: 0.5s;
    -moz-transition: 0.5s;
    max-height: ${props => !props.active ? "0px" : "400px"};
    overflow: hidden;
`

const Sms = (props) => {
    const { active, data } = props;
    return (
        <Wrapper active={active} className="row g-3">
            <TextWrapper title="Nomor Pengirim" description={data.senderName} maxWidth />
            <TextWrapper title="Nama Pengirim" description={data.senderNumber} maxWidth />
        </Wrapper>
    )
}

export default Sms;